module.exports = __webpack_public_path__ + "static/media/US-flag.svg.b08cce47.png";